import React, { memo, useEffect, useState } from "react";
import AdUnit from "./AdUnit";
const RandomImageComponent = React.lazy(() => import('../RandomImageComponent'));

const SidebarAd = memo(({ adUnitsRegistered, supportsAvif }) => {
  const [adRendered, setAdRendered] = useState(false);

  return (
    <div className="md:col-start-3">
      <AdUnit adUnitCode="sidebar-top" onAdRendered={setAdRendered} />
      
      {!adRendered && (


        <>
          <div className="flex justify-center items-center">
            <div id="dsk-box-ad-a" className="hidden-sm" />
            <div id="mob-box-ad-c" className="md:hidden" />
          </div>
          {/*<RandomImageComponent supportsAvif={supportsAvif} />*/}
        </>
      )}
    </div>
  );
});

export default SidebarAd; 
